import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { db } from '../config/firebase';
import { collection, getDocs } from 'firebase/firestore';

export default function QRCodePage() {
  const [listings, setListings] = useState([]);
  const baseUrl = 'https://listlytics.vercel.app/property';

  useEffect(() => {
    const fetchListings = async () => {
      const snapshot = await getDocs(collection(db, 'listings'));
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setListings(data);
    };
    fetchListings();
  }, []);

  const handlePrint = (listingId) => {
    const printWindow = window.open('', '_blank');
    const url = `${baseUrl}/${listingId}`;
    printWindow.document.write(`
      <html><body style="text-align:center; font-family:sans-serif; padding:40px">
        <h2>Scan to view this property</h2>
        <div id="qr"></div>
        <p style="font-size:12px; color:#999">${url}</p>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>
        <script>
          new QRCode(document.getElementById("qr"), {
            text: "${url}", width: 256, height: 256
          });
          setTimeout(() => window.print(), 500);
        </script>
      </body></html>
    `);
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🏠 My Listings — QR Codes</h1>
      {listings.map(listing => (
        <div key={listing.id} style={styles.card}>
          <div style={styles.info}>
            <p style={styles.address}>{listing.address}</p>
            <p style={styles.price}>${listing.price?.toLocaleString()}</p>
          </div>
          <QRCodeSVG
            value={`${baseUrl}/${listing.id}`}
            size={120}
          />
          <button style={styles.button} onClick={() => handlePrint(listing.id)}>
            🖨️ Print QR
          </button>
        </div>
      ))}
    </div>
  );
}

const styles = {
  container: { maxWidth: 480, margin: '0 auto', padding: 20, fontFamily: 'sans-serif' },
  title: { fontSize: 22, fontWeight: 'bold', marginBottom: 20 },
  card: { border: '1px solid #eee', borderRadius: 12, padding: 20,
    marginBottom: 16, display: 'flex', flexDirection: 'column', alignItems: 'center' },
  info: { width: '100%', marginBottom: 16 },
  address: { fontSize: 16, fontWeight: 'bold', margin: '0 0 4px' },
  price: { fontSize: 14, color: '#2E86AB', margin: 0 },
  qr: { marginBottom: 16 },
  button: { background: '#2E86AB', color: '#fff', border: 'none',
    borderRadius: 8, padding: '10px 20px', fontSize: 15, cursor: 'pointer' }
};